export const AutoHoldType = {
  OFF: "OFF",
  QUICK_REPLY_ONLY: "QUICK_REPLY_ONLY",
  ALL_REPLY: "ALL_REPLY",
  ALL_REPLY_PREFERRED_ONLY: "ALL_REPLY_PREFERRED_ONLY",
} as const;

export type AutoHoldType = (typeof AutoHoldType)[keyof typeof AutoHoldType];
